<app-card *ngIf="dealer" [title]="'admin.dealer.show.billing_account_information'|translate" [cardOptionBtnIcon]="'fa fa-repeat'" [cardOptionBtn]="false" [advanceButton]="dealer.exactId" [advancedButtons]="advancedButtons" (outputButtonAdvance)="calFunction($event)">
  <nav ngbNav #nav="ngbNav" class="nav nav-tabs">
    <div ngbNavItem>
      <a ngbNavLink class="nav-link">{{'admin.dealer_info.general'|translate}}</a>
      <ng-template ngbNavContent>
        <div class="row pt-2">
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.companyName'|translate}}</p>
            <label class="m-b-15">{{dealer.companyName}}</label>
          </div>
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.address'|translate}}</p>
            <label class="m-b-15">{{dealer.address}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.zipCode'|translate}}</p>
            <label class="m-b-15">{{dealer.zipCode}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.city'|translate}}</p>
            <label class="m-b-15">{{dealer.city}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.country'|translate}}</p>
            <label class="m-b-15" *ngIf="dealer.country">{{dealer.country.name}}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.phone'|translate}}</p>
            <label class="m-b-15">{{dealer.companyPhone}}</label>
          </div>
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.email'|translate}}
              ({{'admin.dealer_info.general'|translate}})</p>
            <label class="m-b-15">{{dealer.companyEmail}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.website'|translate}}</p>
            <label class="m-b-15">{{dealer.website}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.cocNumber'|translate}}</p>
            <label class="m-b-15">{{dealer.cocNumber}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.vatNumber'|translate}}</p>
            <label class="m-b-15">{{dealer.vatNumber}}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.store_type'|translate}}</p>
            <label class="m-b-15">{{dealer.dealerType?.name|translate}}</label>
          </div>
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.buitendienst'|translate}}</p>
            <label class="m-b-15">{{dealer.buitendienst}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.status'|translate}}</p>
            <span *ngIf="!editStatus">
              <label class="m-b-15" [ngSwitch]="dealer.status">
                <span *ngSwitchCase="getDealer().INVOICEDEALER_ACTIVE">{{'global.active'|translate}}</span>
                <span *ngSwitchCase="getDealer().INVOICEDEALER_ON_HOLD">{{'global.on_hold'|translate}}</span>
                <span *ngSwitchCase="getDealer().INVOICEDEALER_INACTIVE">{{'global.inactive'|translate}}</span>
              </label>
              <a (click)="activateEditStatus()" class="action-button ripple light">
                <i class="fa fa-pencil p-2"></i>
              </a>
            </span>
            <ng-select [items]="statuses" *ngIf="editStatus" (change)="saveStatus($event)" class="w-50" [(ngModel)]="dealer.status" bindLabel="label" bindValue="value" [clearable]="false"></ng-select>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.dealer_number'|translate}}</p>
            <label class="m-b-15">{{dealer.debtor}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.profile'|translate}}</p>
            <span *ngIf="!editProfile">
              <label class="m-b-15">{{getDealerProfiles(dealer.profiles)}}</label>
              <a (click)="activateEditProfile()" class="action-button ripple light">
                <i class="fa fa-pencil p-2"></i>
              </a>
            </span>
            <ng-select [items]="profileOptions" *ngIf="editProfile" (change)="saveProfile($event)" [(ngModel)]="currentDealerProfiles" bindLabel="label" bindValue="value" [clearable]="false" [multiple]="true"></ng-select>
          </div>
        </div>
      </ng-template>
    </div>
    <div ngbNavItem>
      <a ngbNavLink class="nav-link">{{'admin.dealer_info.financial'|translate}}</a>
      <ng-template ngbNavContent>
        <div class="row pt-2">
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.companyName'|translate}}</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.companyName}}</label>
          </div>
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.address'|translate}}</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.address}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.zipCode'|translate}}</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.zipCode}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.city'|translate}}</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.city}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.country'|translate}}</p>
            <label class="m-b-15" *ngIf="dealer.invoiceDealer?.country">{{dealer.invoiceDealer.country.name}}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.phone'|translate}}</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.phone}}</label>
          </div>
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.email'|translate}}
              ({{'doctrine.invoice_dealer.invoice_email'|translate}})</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.email}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.cocNumber'|translate}}</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.cocNumber}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.vatNumber'|translate}}</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.vatNumber}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.paymentCondition'|translate}}</p>
            <label class="m-b-15">{{getPaymentCondition(dealer.invoiceDealer?.paymentCondition)}}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.bundleInvoices'|translate}}</p>
            <label *ngIf="!editBundleInvoice" class="m-b-15">
              {{(dealer.invoiceDealer?.bundleInvoices ? 'global.yes' : 'global.no') | translate}}
              <a (click)="activateEditBundleInvoices()" class="action-button ripple light">
                <i class="fa fa-pencil p-2"></i>
              </a>
            </label>
            <ng-select [items]="yesNoOptions" *ngIf="editBundleInvoice" (change)="saveBundleStatus($event)" class="w-50"
                       [(ngModel)]="dealer.invoiceDealer.bundleInvoices"
                       bindLabel="label" bindValue="value" [clearable]="false">
            </ng-select>
          </div>
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.salesVatCode'|translate}}</p>
            <label class="m-b-15">
              {{dealer.invoiceDealer?.salesVatPercentage}}%
            </label>
          </div>
        </div>
      </ng-template>
    </div>
  </nav>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</app-card>

